export const customerOptionSelector = state => state.entities.customerOptions;
